import { Dispatch } from "redux"
import { toast } from "react-toastify"
import { setSyncLog } from "./reducer"
import SyncLog, { SyncLogTypes } from "models/sync-log"

// GET /sync-log/:moduleName
export const getMostRecentSyncLog = (moduleName: SyncLogTypes) => async (dispatch: Dispatch) => {
  try {
    const url = `${process.env.REACT_APP_API_URL}/sync-log/${moduleName}`

    const res = await fetch(url, {
      credentials: "include",
      method: "GET",
    })

    if (!res.ok) {
      const errBody = await res.json()
      throw new Error(errBody.message)
    }

    const data = await res.json()
    dispatch(setSyncLog({ moduleName, data: data.data }))
    return data.data

  } catch (err: any) {
    toast.error(err.message ?? "Error getting most recent sync log")
    return null
  }
}

// GET /sync-log/:moduleName without toasts or dispatches: used to poll while a sync runs.
// Returns null when there is no log yet or the request fails.
export const fetchMostRecentSyncLog = async (moduleName: SyncLogTypes): Promise<SyncLog | null> => {
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/sync-log/${moduleName}`, {
      credentials: "include",
      method: "GET",
    })
    if (!res.ok) return null
    const data = await res.json()
    return data.data ?? null
  } catch {
    return null
  }
}
